export const DESCRIPTION = [
  'the photographer’s first encounter with emma, as she is seen going down a staircase',
  'the photographer continues to follow emma from behind before scouting her',
  'the photographer has briefed emma about the modeling contract and has instructed her to do her own makeup for her very first comp card',
  'EMMA TANG (FRONTAL CLOSE UP)',
  'EMMA TANG (PROFILE CLOSE UP)',
  'EMMA TANG (FRONTAL FULL BODY)',
  'EMMA TANG (SIDE FULL BODY)',
  'EMMA TANG COMP CARD FULL BODY',
  'EMMA TANG COMP CARD CLOSE UP',
  'in the process of editing emma ‘s comp card',
  'in the process of editing emma ‘s comp card while eating fried chicken and fries in shake shack',
  'in the process of editing emma ‘s comp card while eating fried chicken and fries in shake shack',
  'the comp card has now been printed as flyers and ready to be distributed, they are stored inside the locker in hong kong post office.',
  'the comp cards will be distributed by the local auntie, coincidentally looking similar to emma . ',
  'the auntie takes out the comp cards from the locker.',
  'the auntie notices the presence of the photographer, becoming annoyed as it intrudes her privacy.',
  'the auntie forbids the photographer to take picture of her.',
  'and yet the photographer still follows her from behind and attempt to take picture of the auntie from afar in a corridor.',
  'Sunday noon in Central station, outside of exit A. The bridge is bustling with female domestic workers taking their days off.',
  'Sunday noon in Central station, outside of exit A. The bridge is bustling with female domestic workers taking their days off.',
  'There’s no Sunday holiday for the auntie, though. Today she will be busy distributing the comp cards flyers to people on the Central station bridge.',
  'Tiredness can’t help but grow on Auntie, as she yawns.',
  'Auntie is seen going up a staircase, but her rheumatic legs gave out at last minute.',
  'She keeps her composure and keeps her focus on today’s goal: distributing emma ‘s comp cards.',
  'Busy Central bridge',
  'Some policewomen passing in front of Auntie.',
  'Auntie on action, handing out emma ‘s comp card to passerby that barely looks at her.',
  'Auntie, up, close and personal.',
  'The elegant Madame emma is trotting in her business casual attire. On the phone with a potential investor.',
  '“Time to close the deal.” Madame emma confirms whoever is on the other line of the phone.',
  'She hangs up her phone after successfully closing the business deal of the year. A perfect, dramatic shot of Madame emma as the wind blows her hair.',
  'Auntie saw Madame too as a business opportunity for her. She confidently hands out emma ‘s comp card towards the Madame.',
  'Madame emma took a curious glance at the comp card.',
  'Bustling bridge',
  'Madame emma faces Auntie',
  'and she accepts emma ‘s comp card',
  'Auntie successfully distributes emma ‘s comp card to Madame',
  'Madame folds the comp card and slides it in her briefcase for safekeeping',
  
  'A glimpse of what is inside Madame’s briefcase: emma ‘s compcard, passport, laptop, confidential immigration documents.',
  
  'We bids Auntie farewell, as of now',
  
  'Madame emma walks away from the bridge scene',
  
  'Madame walks outside her office door with intent',
  
  'Passing thru the office door',
  
  'Passing thru the office door',
  
  'A luggage',
  
  'Madame emma opens her passport, seemingly going for a trip somewhere…',
  
  'Madame emma scrutinizes over her passport',
  
  'Madame emma walks with her luggage and passport',
  
  'A passport',
  
  'Glasses, watch, and emma ‘s comp card',
  
  'The window pane of Hong Kong International Airport',
  
  'Madame emma approaches the Hong Kong International Airport',
  
  'Madame emma rushes for her flight',
  
  'Madame emma rushes for her flight',
  
  'Crowded travelator in mid levels Central',
  
  'emma resting her arms on the side of the travelator. It is her first gig post-scouted.',
  
  'emma awaiting the traffic to clear out outside the Mid Levels lift before walking for the next shot',
  
  'emma being instructed by the photographer to pretend picking up a phone call. Who is on the other line? maybe the Madame?',
  
  'the shot of emma calling somebody in the middle of the street',
  
  'the photographer instructs emma to walk the other way',
  
  'oops, she goes the wrong way',
  
  'A car passes by',
  
  'A retouched shot of emma looking at her phone in the middle of streets featuring Lousy’s work',
  
  'A retouched close up shot of emma with a soft glam look',
  'emma finishes her final shot in front of a hotel building. Exhausted by her corsette that she wore for the whole afternoon.',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma looks back to the photographer',
  'emma checks back with the photographer, "We are truly done with the shoot yeah?"',
  'the photographer confirms and so emma walks back again',
  'a glimpse of a man looking towards emma',
  'a middle-aged man whistled, potentially towards the fact that a woman (i.e, emma), is walking in front of him.',
  'the man shamelessly still continues his non-virtuosic whistling',
  'the photographer makes sure to catch a shot of the whistling man. The man looks at a woman, the photographer then also would like to look back at the man.',
  'the photographer walks pass the man',
  'the perverted man is now cannot be seen in the scene',
  'emma came back within the vicinity of the photographer',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
  'emma walks away from the last shot',
'emma approaches her home',
'emma exits the photoshoot and separates with the photographer.',
  ]